export default {
  'contact-mail': 'blog@pixartprinting.com',
  'business-name': 'Pixartprinting S.p.A. unique actionnaire',
  'privacy-policy': 'Politique de Confidentialité',
}
